import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

export type AppLanguage = "en" | "ru";

const STORAGE_KEY = "twap:language:v1";

const EN: Record<string, string> = {
  "ENG": "ENG",
  "RUS": "RUS",
  "Language": "Language",
  "Switch language": "Switch language",
  "Public menu": "Public menu",
  "Social links": "Social links",
  "Как это работает": "How it works",
  "Скринер TWAP для анализа крупных алгоритмов": "TWAP screener for analyzing large algorithms",
  "TWAP DETECT - это крипто-скринер TWAP для трейдеров, которые отслеживают крупные алгоритмические ордера, кошельки и рыночный контекст до входа в сделку.":
    "TWAP DETECT is a crypto TWAP screener for traders who track large algorithmic orders, wallets, and market context before entering a trade.",
  "Процесс работы TWAP DETECT": "TWAP DETECT workflow",
  "Входные данные": "Input",
  "Обработка": "Processing",
  "Результат": "Output",
  "TWAP DETECT получает публичные данные о запущенных TWAP-алгоритмах, кошельках, стакане и свечах рынка.":
    "TWAP DETECT reads public data about active TWAP algorithms, wallets, order books, and market candles.",
  "Скринер группирует ордера, считает силу TWAP, влияние на цену, винрейт кошелька, исторический диапазон и контекст BTC.":
    "The screener groups orders and calculates TWAP strength, price impact, wallet win rate, historical range, and BTC context.",
  "Пользователь видит карточку с торговым контекстом, алертом и ссылкой на статистику для самостоятельного решения.":
    "The user sees a card with trading context, an alert, and a statistics link for an independent decision.",
  "Сценарии использования": "Use cases",
  "Найти крупный TWAP на Hyperliquid до того, как движение станет очевидным на графике.":
    "Find a large TWAP on Hyperliquid before the move becomes obvious on the chart.",
  "Проверить, как похожие алгоритмы этого кошелька отрабатывали раньше.":
    "Check how similar algorithms from the same wallet performed before.",
  "Отфильтровать слабые ситуации по силе, винрейту, влиянию на цену и прогрессу исполнения.":
    "Filter weak setups by strength, win rate, price impact, and execution progress.",
  "Данные, безопасность и ограничения": "Data, security, and limitations",
  "TWAP DETECT использует публичные рыночные и on-chain данные; приватные биржевые API-ключи для просмотра скринера не требуются.":
    "TWAP DETECT uses public market and on-chain data; private exchange API keys are not required to view the screener.",
  "Сервис показывает аналитику и ограничения данных, но не гарантирует прибыль и не заменяет управление риском.":
    "The service shows analytics and data limitations, but it does not guarantee profit or replace risk management.",
  "Open screener": "Open screener",
  "Log in": "Log in",
  "Sign up": "Sign up",
  "Close": "Close",
  "Account": "Account",
  "Login": "Login",
  "New login": "New login",
  "Add login": "Add login",
  "Email": "Email",
  "Add email": "Add email",
  "Unlink email": "Unlink email",
  "Link Telegram": "Link Telegram",
  "Unlink Telegram": "Unlink Telegram",
  "Registration date": "Registration date",
  "Subscription status": "Subscription status",
  "Remaining": "Remaining",
  "Change password": "Change password",
  "Password change unavailable": "Password change unavailable",
  "Sign out": "Sign out",
  "Contact support": "Contact support",
  "Recovery": "Recovery",
  "Security": "Security",
  "New password": "New password",
  "Repeat password": "Repeat password",
  "Save password": "Save password",
  "Password changed": "Password changed",
  "Adding...": "Adding...",
  "Add": "Add",
  "Добавить": "Add",
  "+ Добавить": "+ Add",
  "Check email": "Check email",
  "Saving...": "Saving...",
  "Not specified": "Not specified",
  "Expired": "Expired",
  "No subscription": "No subscription",
  "Payment pending": "Payment pending",
  "Active": "Active",
  "Canceled": "Canceled",
  "Beginner": "Beginner",
  "Experienced": "Experienced",
  "Professional": "Professional",
  "Subscription": "Subscription",
  "Новичок": "Beginner",
  "Опытный": "Experienced",
  "Профессионал": "Professional",
  "Подписка": "Subscription",
  "Ожидает оплаты": "Payment pending",
  "Активна": "Active",
  "Истекла": "Expired",
  "Отменена": "Canceled",
  "Без подписки": "No subscription",
  "Аккаунт": "Account",
  "Закрыть аккаунт": "Close account",
  "Логин": "Login",
  "Новый логин": "New login",
  "Добавить логин": "Add login",
  "Отвязать email": "Unlink email",
  "Добавить email": "Add email",
  "Отвязать Telegram": "Unlink Telegram",
  "Привязать Telegram": "Link Telegram",
  "Дата регистрации": "Registration date",
  "Статус подписки": "Subscription status",
  "Осталось": "Remaining",
  "Пароль изменен": "Password changed",
  "Сменить пароль": "Change password",
  "Смена пароля недоступна": "Password change unavailable",
  "Выйти из аккаунта": "Sign out",
  "Связаться с поддержкой": "Contact support",
  "Закрыть добавление email": "Close add email",
  "Восстановление": "Recovery",
  "Добавляю...": "Adding...",
  "Проверить e-mail": "Check email",
  "Закрыть смену пароля": "Close password change",
  "Безопасность": "Security",
  "Текущий пароль": "Current password",
  "Новый пароль": "New password",
  "Повторите пароль": "Repeat password",
  "Сохраняю...": "Saving...",
  "Сохранить пароль": "Save password",
  "Пароль должен быть не короче 6 символов.": "Password must be at least 6 characters.",
  "Пароли не совпадают.": "Passwords do not match.",
  "Введите текущий пароль.": "Enter your current password.",
  "Смена пароля сейчас недоступна.": "Password change is unavailable right now.",
  "Не удалось изменить пароль. Выберите другой новый пароль.":
    "Could not change the password. Choose a different new password.",
  "Введите корректный email.": "Enter a valid email.",
  "Добавление email сейчас недоступно.": "Adding email is unavailable right now.",
  "Не удалось добавить email.": "Could not add email.",
  "Email отправлен на подтверждение. Подтвердите письмо и нажмите «Проверить e-mail».":
    "A confirmation email has been sent. Confirm it, then click \"Check email\".",
  "Email добавлен.": "Email added.",
  "Проверка email сейчас недоступна.": "Email verification is unavailable right now.",
  "Email ещё не подтверждён или недоступен.": "Email is not confirmed yet or is unavailable.",
  "Отвязка email сейчас недоступна.": "Unlinking email is unavailable right now.",
  "Не удалось отвязать email.": "Could not unlink email.",
  "Email отвязан.": "Email unlinked.",
  "Логин: 3-32 символа, латиница, цифры и _.": "Login: 3-32 characters, Latin letters, digits, and _.",
  "Добавление логина сейчас недоступно.": "Adding login is unavailable right now.",
  "Не удалось добавить логин.": "Could not add login.",
  "Логин добавлен.": "Login added.",
  "Telegram привязан.": "Telegram linked.",
  "Отвязка Telegram сейчас недоступна.": "Unlinking Telegram is unavailable right now.",
  "Не удалось отвязать Telegram.": "Could not unlink Telegram.",
  "Telegram отвязан.": "Telegram unlinked.",
  "Сначала добавьте email, чтобы не потерять доступ к аккаунту.":
    "Add an email first so you do not lose access to the account.",
  "Сначала привяжите Telegram": "Link Telegram first",
  "Этот Telegram уже привязан к другому аккаунту.":
    "This Telegram is already linked to another account.",

  "Скринер алгоритмов": "Algorithm screener",
  "В скринер": "Open screener",
  "Публичное меню": "Public menu",
  "Социальные сети": "Social links",
  "Основное меню": "Main menu",
  "Админка": "Admin",
  "Восстановление пароля": "Password recovery",
  "Примеры реальные карточки TWAP": "Real TWAP card examples",
  "Примеры реальных карточек TWAP": "Real TWAP card examples",
  "Слайды блока аналитики": "Analytics section slides",
  "Показать слайд": "Show slide",
  "Пример карточки скринера": "Screener card example",
  "Пример таблицы статистики": "Statistics table example",
  "обновляется каждые 30 дней": "updated every 30 days",
  "FAQ по TWAP DETECT": "TWAP DETECT FAQ",
  "Вход": "Log in",
  "Войти": "Log in",
  "Регистрация": "Sign up",
  "Зарегистрироваться": "Sign up",
  "Смотреть тарифы": "View plans",
  "Почему трейдеры смотрят сюда": "Why traders watch this",
  "Там, где другие видят шум - мы видим сигнал":
    "Where others see noise, we see a signal",
  "Аналитика - залог успеха": "Analytics turns signals into trades",
  "Калькулятор": "Calculator",
  "за последние": "over the last",
  "дней": "days",
  "день": "day",
  "дня": "days",
  "TWAP за последние 30 дней": "TWAPs over the last 30 days",
  "Всего найдено": "Total found",
  "Берём в расчёт": "Used in the model",
  "После фильтрации шума": "After filtering noise",
  "Остаётся 30%": "30% remain",
  "Торгуем только их": "Only these are traded",
  "Депозит для расчёта": "Deposit for calculation",
  "Примерная прибыль": "Estimated profit",
  "за 30 дней": "over 30 days",
  "Доходность на объём сделки за 30 дней": "Return on trade size over 30 days",
  "Берём последние 30 дней, фильтруем TWAP от 50% винрейта и открываем сделки только по алгоритмическим ситуациям. Ниже - фактическая прибыль за период от депозита, который вы ввели слева.":
    "We take the last 30 days, filter TWAPs from a 50% win rate, and trade only algorithmic setups. Below is the actual period return for the deposit entered on the left.",
  "Доступ к скринеру": "Screener access",
  "Три уровня подписки": "Three subscription tiers",
  "Выбрать": "Choose",
  "/ месяц": "/ month",
  "месяц": "month",
  "мес": "mo",
  "Обновить отображение по моим фильтрам": "Refresh view with my filters",
  "Сбросить все фильтры": "Reset all filters",
  "Изменения применяются автоматически": "Changes apply automatically",

  "Моментальное отображение карточки после индексации.":
    "Instant card display after indexing.",
  "⚡ <10мс": "⚡ <10ms",
  "<10мс": "<10ms",
  "Торговля через скринер": "Trading through the screener",
  "Торговля прямо через скринер без ввода API. Торгуй через лучший терминал MetaScalp - это дает преимущество в скорости перед другими трейдерами.":
    "Trade directly from the screener without entering exchange API keys. Use the MetaScalp terminal to gain an execution-speed edge over other traders.",
  "Фильтры": "Filters",
  "Фильтры отсекают слабые ситуации и оставляют сильные алгоритмы, которые могут создать давление на рынок и довести цену до Take-Profit.":
    "Filters remove weak setups and keep strong algorithms that can pressure the market and push price toward take profit.",
  "Алерты": "Alerts",
  "Звуковые и голосовые алерты помогают не пропустить ситуацию и держат вас в курсе событий.":
    "Sound and voice alerts help you catch setups and stay updated.",
  "Рыночные данные": "Market data",
  "Моментальная аналитика рынка: сила алгоритма и влияние на цену помогают быстро принять решение по сделке.":
    "Instant market analytics: algorithm strength and price impact help you make trade decisions faster.",
  "Винрейт и диапазон": "Win rate and range",
  "На каждой карточке уже проиндексирован диапазон и винрейт участника по его истории.":
    "Each card already contains the trader's historical range and win rate.",
  "История TWAP": "TWAP history",
  "В базе больше 500 тыс. TWAP.": "More than 500k TWAPs in the database.",
  "Есть что торговать": "Plenty to trade",
  "Каждый день торговые ситуации": "Trading setups every day",
  "После индексации.": "After indexing.",

  "BTC-контекст": "BTC context",
  "Рынок помогает или идёт против алгоритма.": "The market either supports or fights the algorithm.",
  "Торговые данные": "Trading data",
  "Размер кошелька, винрейт участника и средний диапазон алгоритма.":
    "Wallet size, participant win rate, and average algorithm range.",
  "Объём TWAP, влияние на цену и сила алгоритма в одной зоне.":
    "TWAP size, price impact, and algorithm strength in one area.",
  "Темп алгоритма": "Algorithm pace",
  "Темп и режим в котором работает алгоритм.": "The pace and mode the algorithm is using.",
  "Статистика": "Statistics",
  "Вся история кошелька в один клик.": "Full wallet history in one click.",
  "Следить": "Follow",
  "Отслеживание отключения алгоритма напрямую через кошелек.":
    "Track algorithm shutdown directly through the wallet.",
  "Прогресс": "Progress",
  "Сколько исполнено и сколько осталось.": "How much is filled and how much remains.",
  "Кошелёк": "Wallet",
  "Кошелек": "Wallet",
  "Кошелёк(и)": "Wallet(s)",
  "Кошелек(и)": "Wallet(s)",
  "Прямая ссылка на трекер кошелька.": "Direct link to the wallet tracker.",
  "Карточка": "Card",
  "Моментальные торговые данные для быстрого анализа торговой ситуации":
    "Instant trading data for fast setup analysis",
  "История кошелька и рыночная статистика в одной таблице":
    "Wallet history and market statistics in one table",

  "Кол-во по тикеру": "Ticker count",
  "направление участника": "participant direction",
  "Завершён по времени": "Finished on time",
  "Скрыть": "Hide",
  "Развернуть": "Expand",
  "Показано": "Shown",
  "Все статусы": "All statuses",
  "Завершён": "Finished",
  "Отключён": "Stopped",
  "Ошибка": "Error",
  "Среднее время TWAP": "Average TWAP time",
  "по истории": "based on history",
  "Влияние цены": "Price impact",
  "за 1 мин (старт)": "in 1 min (start)",
  "Влияние цены\nза 1 мин (старт)": "Price impact\nin 1 min (start)",
  "Влияние при завершении": "Impact at finish",
  "Влияние при\nзавершении TWAP": "Impact at\nTWAP finish",
  "Влияние 1 мин\nпосле завершения": "Impact 1 min\nafter finish",
  "1 мин после завершения": "1 min after finish",
  "после TWAP": "after TWAP",
  "Среднее пиковое": "Average peak",
  "за время TWAP ↑ %": "during TWAP ↑ %",
  "за время TWAP ↓ %": "during TWAP ↓ %",
  "Среднее пиковое\nза время TWAP ↑ %": "Average peak\nduring TWAP ↑ %",
  "Среднее пиковое\nза время TWAP ↓ %": "Average peak\nduring TWAP ↓ %",
  "Средняя сила": "Average strength",
  "Сколько TWAP было у кошелька по HYPE.": "How many HYPE TWAPs the wallet had.",
  "Среднее движение за первую минуту после старта.":
    "Average move during the first minute after start.",
  "Сколько в среднем длится алгоритм у кошелька.":
    "How long this wallet's algorithm runs on average.",
  "Размер TWAP относительно рыночного объёма.":
    "TWAP size relative to market volume.",
  "Статистика по каждому TWAP кошелька.": "Statistics for each wallet TWAP.",
  "Против BTC": "Against BTC",
  "С BTC": "With BTC",
  "Нейтрально": "Neutral",
  "ошибка": "error",
  "завершён": "finished",
  "отключён": "stopped",
  "Рынок против направления": "Market against direction",
  "Рынок нейтральный": "Market neutral",
  "слабый": "weak",
  "заметный": "noticeable",
  "сильный": "strong",
  "очень сильный": "very strong",
  "Выключено": "Off",
  "Не ниже «заметный» (≥5%)": "At least \"noticeable\" (≥5%)",
  "Не ниже «сильный» (≥15%)": "At least \"strong\" (≥15%)",
  "Не ниже «очень сильный» (≥30%)": "At least \"very strong\" (≥30%)",
  "Свой порог (%)": "Custom threshold (%)",
  "Свой порог:": "Custom threshold:",
  "выкл": "off",
  "Режим: догоняющий": "Mode: catching up",
  "Режим:": "Mode:",
  "ровный одиночный": "steady single",
  "ровный дробный": "steady split",
  "неровный дробный": "randomized split",
  "не отслеживается": "untrackable",
  "Фактический темп": "Actual pace",
  "Плановый темп": "Expected pace",
  "Средний темп": "Average pace",
  "Последние 3 части": "Last 3 slices",
  "Плановая часть": "Expected slice",
  "Часть ордера": "Order slice",
  "Влияние за часть": "Impact per slice",
  "Влияние в минуту": "Impact per minute",
  "Режимы участников": "Participant modes",
  "Причина": "Reason",
  "ждём первые сделки": "waiting for first fills",
  "не найден ID TWAP": "TWAP ID not found",
  "нет размера или времени": "missing size or duration",
  "ещё нет сделок": "no fills yet",
  "некорректный TWAP": "invalid TWAP",
  "ждём сделки": "waiting for fills",
  "пока не понятен": "not clear yet",
  "обновляется": "updating",
  "Режим частей": "Slice mode",
  "ЛОНГ": "LONG",
  "ШОРТ": "SHORT",
  "кош.": "wallet",
  "вин.": "win",
  "Пик": "Peak",
  "Открыть статистику": "Open statistics",
  "Объём TWAP": "TWAP size",
  "Влияние на рынок": "Market impact",
  "ВЛИЯНИЕ НА РЫНОК": "MARKET IMPACT",
  "Влияние на цену": "Price impact",
  "Сила TWAP": "TWAP strength",
  "Исполнение": "Execution",
  "Размеры": "Sizes",
  "Кошельки": "Wallets",
  "Навигация между блоками": "Section navigation",
  "Предыдущий экран": "Previous screen",
  "Следующий экран": "Next screen",
  "Статистика по тикеру": "Ticker statistics",
  "РЫНОЧНЫЕ ДАННЫЕ": "MARKET DATA",
  "Все": "All",
  "ВСЕ": "ALL",
  "Всего": "Total",
  "/мин": "/min",
  "мин": "min",
  "Направление": "Direction",
  "BTC фон": "BTC backdrop",
  "Статус": "Status",
  "Старт (UTC)": "Start (UTC)",
  "Конец (UTC)": "End (UTC)",
  "План, мин": "Plan, min",
  "Факт, мин": "Actual, min",
  "Размер, монет": "Size, coins",
  "Номинал, USDC": "Notional, USDC",
  "Цена нач.": "Start price",
  "Цена кон.": "End price",
  "Изм., %": "Change, %",
  "Пик ↑, %": "Peak ↑, %",
  "Пик ↓, %": "Peak ↓, %",
  "Сила TWAP, %": "TWAP strength, %",

  "Что такое скринер TWAP DETECT?": "What is the TWAP DETECT screener?",
  "TWAP DETECT отслеживает запуск TWAP-алгоритмов на рынке криптовалют и присылает готовые алерты.":
    "TWAP DETECT tracks the launch of TWAP algorithms in crypto markets and sends ready-to-use alerts.",
  "В алерте отображаются рыночные данные, статистика по кошельку, винрейт, сила TWAP, время работы алгоритма и история похожих ситуаций.":
    "Each alert shows market data, wallet statistics, win rate, TWAP strength, algorithm runtime, and similar historical cases.",
  "Что такое TWAP?": "What is TWAP?",
  "TWAP-алгоритм делит крупный ордер на несколько частей и исполняет их через равные промежутки времени.":
    "A TWAP algorithm splits a large order into smaller parts and executes them at regular intervals.",
  "Такой алгоритм может создавать давление на цену криптовалюты и постепенно двигать рынок вверх или вниз.":
    "This can create pressure on a crypto asset and gradually move the market up or down.",
  "Как торговать по TWAP DETECT?": "How do I trade with TWAP DETECT?",
  "Торговля строится по алертам из скринера. Когда появляется запущенный TWAP, трейдер смотрит силу, винрейт, влияние на цену, время работы и исторический диапазон.":
    "Trading is based on screener alerts. When a live TWAP appears, the trader checks strength, win rate, price impact, runtime, and historical range.",
  "Идея в том, чтобы зайти ближе к запуску алгоритма и выйти ближе к окончанию его работы.":
    "The idea is to enter close to the algorithm start and exit closer to its completion.",
  "Какие данные в алерте самые важные?": "Which alert data matters most?",
  "Новичку в первую очередь стоит смотреть на силу TWAP, время работы, влияние на цену, винрейт и исторический диапазон.":
    "Beginners should first watch TWAP strength, runtime, price impact, win rate, and historical range.",
  "Чем сильнее TWAP и чем лучше статистика похожих алгоритмов, тем вероятней исход.":
    "The stronger the TWAP and the better the statistics for similar algorithms, the more probable the outcome.",

  "Старт": "Start",
  "для знакомства": "for getting started",
  "База": "Base",
  "Базовая подписка для первого знакомства.": "Basic subscription for your first look.",
  "Трейдер": "Trader",
  "рабочий режим": "daily trading",
  "Лучший выбор": "Best choice",
  "Рабочий сетап для торговли и анализа рыночных данных.":
    "A practical setup for trading and market-data analysis.",
  "Профи": "Pro",
  "полный контроль": "full control",
  "Максимум": "Maximum",
  "Максимальный доступ. Анализ полной истории рыночных торгов.":
    "Maximum access. Full market-trade history analysis.",
  "Торговля": "Trading",
  "Торговля через MetaScalp": "Trading via MetaScalp",
  "Тикер": "Ticker",
  "Сторона (Long / Short)": "Side (Long / Short)",
  "Режим работы алгоритма": "Algorithm mode",
  "BTC-индикатор": "BTC indicator",
  "Баланс кошелька": "Wallet balance",
  "Настройки": "Settings",
  "Открыть настройки": "Open settings",
  "Закрыть настройки": "Close settings",
  "Разделы настроек": "Settings sections",
  "Общее": "General",
  "Блок сортировки": "Sort block",
  "Звуковые алерты": "Sound alerts",
  "Чёрный список": "Blacklist",
  "Чёрный список (тикеры)": "Ticker blacklist",
  "Свой звук для белого списка": "Custom whitelist sound",
  "Звук white-list алерта": "Whitelist alert sound",
  "Winrate алгоритма": "Algorithm win rate",
  "Пики (диапазон торговли алгоритма)": "Peaks (algorithm trading range)",
  "Прямая подписка на кошелек": "Direct wallet follow",
  "Звуковые и голосовые алерты": "Sound and voice alerts",
  "Telegram-алерты": "Telegram alerts",
  "Полный набор фильтров": "Full filter set",
  "Белый список кошельков": "Wallet whitelist",
  "Черный список кошельков": "Wallet blacklist",
  "Белый список": "Whitelist",

  "Логин или email": "Login or email",
  "Пароль": "Password",
  "Авторизоваться через Telegram": "Log in with Telegram",
  "Создать аккаунт через Telegram": "Create account with Telegram",
  "Нет аккаунта?!": "No account?",
  "Есть аккаунт?": "Already have an account?",
  "Восстановить пароль": "Reset password",
  "Подождите...": "Please wait...",
  "Отправляем...": "Sending...",
  "Повторно через": "Again in",
  "Вспомнили пароль?": "Remembered your password?",
  "Письмо для восстановления отправлено на email.":
    "Password reset email has been sent.",
  "Неверный пароль или аккаунт не найден.":
    "Invalid password or account not found.",
  "Этот логин занят.": "This login is already taken.",
  "Этот email занят.": "This email is already taken.",
  "Аккаунт не найден.": "Account not found.",
  "Авторизация ещё не настроена.": "Authorization is not configured yet.",
  "Введите логин, email и пароль.": "Enter login, email, and password.",
  "Введите логин или email и пароль.": "Enter login or email and password.",
  "Введите логин или email.": "Enter login or email.",
  "Не удалось проверить аккаунт. Попробуйте ещё раз.":
    "Could not verify the account. Try again.",
  "Аккаунт создан, но вход не подтвердился. Попробуйте войти ещё раз.":
    "The account was created, but sign-in was not confirmed. Try signing in again.",
  "Новую ссылку можно отправить через": "A new link can be sent in",
  "сек.": "sec.",

  "Оплата через CryptoBot ещё не настроена.": "CryptoBot payment is not configured yet.",
  "Оплата криптовалютой ещё не настроена.": "Crypto payment is not configured yet.",
  "Не удалось открыть оплату. Попробуйте ещё раз или напишите в поддержку.":
    "Could not open payment. Try again or contact support.",
  "низкая комиссия": "low fee",
  "Не удалось сменить тариф за счёт остатка. Попробуйте ещё раз или напишите в поддержку.":
    "Could not switch the plan using remaining balance. Try again or contact support.",
  "Остатка текущего тарифа уже не хватает для смены без доплаты. Обновите тарифы и попробуйте ещё раз.":
    "Your remaining plan balance is no longer enough to switch without payment. Refresh the plans and try again.",
  "Этот тариф уже активен. Для него доступно продление.":
    "This plan is already active. You can renew it.",
  "Вход через Telegram ещё не настроен.": "Telegram login is not configured yet.",
  "Не удалось войти через Telegram. Попробуйте ещё раз.":
    "Could not log in via Telegram. Try again.",
  "Аккаунт Telegram не найден.": "Telegram account not found.",
  "Аккаунт Telegram уже есть. Войдите через Telegram.":
    "Telegram account already exists. Log in via Telegram.",
  "Telegram работает только на домене из BotFather.":
    "Telegram works only on the domain configured in BotFather.",

  "Данные устарели": "Data is stale",
  "Данные могут быть неполными": "Data may be incomplete",
  "Источник Hypurrscan не отвечает уже": "Hypurrscan has not responded for",
  "Новые TWAP не приходят. Это сбой источника, а не отсутствие рынка.":
    "New TWAPs are not arriving. This is a source outage, not an empty market.",
  "Источник Hypurrscan не отвечает": "Hypurrscan is not responding for",
  "Карточки и алерты могут отставать.": "Cards and alerts may lag.",
  "Сортировка": "Sort",
  "По умолчанию": "Default",
  "Белые кошельки": "Whitelisted wallets",
  "Отслеживаемые": "Followed",
  "Новые": "New",
  "Размер": "Size",
  "Время": "Time",
  "Сила": "Strength",
  "Влияние": "Impact",
  "Мои подписки": "My follows",
  "Подписки": "Follows",
  "Отписаться": "Unfollow",
  "Открыть сделку": "Open trade",
  "MetaScalp не запущен": "MetaScalp is not running",
  "Запустите MetaScalp терминал (порт 17845-17855)":
    "Start the MetaScalp terminal (port 17845-17855)",
  "Открыть рыночный ордер через MetaScalp": "Open a market order through MetaScalp",
  "Закрытие позиций": "Closing positions",
  "Закрытие…": "Closing...",
  "слот": "slot",
  "слота": "slots",
  "слотов": "slots",
  "Закрыть": "Close",
  "данные обновляются": "data is updating",
  "PnL около нуля": "PnL is near zero",
  "Закрыть позиции на всех слотах": "Close positions on all slots",
  "Сделка закрыта": "Trade closed",
  "Не удалось закрыть": "Could not close",
  "Слот": "Slot",
  "загрузка…": "loading...",
  "Настроен": "Configured",
  "Выберите подключение": "Select connection",
  "Баланс": "Balance",
  "Удалить слот": "Delete slot",
  "Подключение MetaScalp": "MetaScalp connection",
  "Нет подключений в MetaScalp": "No MetaScalp connections",
  "Не найдено": "Not found",
  "Режим расчёта суммы": "Order size mode",
  "Плечо": "Leverage",
  "ставится в MetaScalp терминале": "set in the MetaScalp terminal",
  "Сумма ордера": "Order size",
  "Фиксированная — не зависит от баланса": "Fixed, independent of balance",
  "Сумма ордера =": "Order size =",
  "баланс ×": "balance ×",
  "Каждая сделка открывается на": "Each trade opens for",
  "независимо от баланса": "regardless of balance",
  "Защита аккаунта": "Account protection",
  "Скринер уже открыт в другой вкладке": "The screener is already open in another tab",
  "Закройте первую вкладку со скринером. После освобождения аккаунта эта страница откроется автоматически.":
    "Close the first screener tab. This page will open automatically after the account is released.",
  "Аккаунт открыт на другом устройстве": "The account is open on another device",
  "Скринер доступен только в одной активной сессии. Закройте скринер на другом устройстве или выйдите из аккаунта там.":
    "The screener is available in only one active session. Close it on the other device or sign out there.",
  "Проверяем защиту аккаунта": "Checking account protection",
  "Скринер откроется автоматически, когда проверка активной сессии завершится.":
    "The screener will open automatically when the active-session check is complete.",
  "Сессия скринера освобождена": "Screener session released",
  "Пробую вернуть доступ. Если экран не исчезает, войдите в аккаунт заново.":
    "Trying to restore access. If this screen does not disappear, sign in again.",
  "Нет активной сессии аккаунта.": "No active account session.",
  "Последняя активность": "Last activity",
  "Повторить снова": "Try again",
  "Проверить снова": "Check again",
  "Нужно войти в аккаунт": "You need to sign in",

  "Выберите продление текущего тарифа или смену тарифа с зачётом остатка.":
    "Choose renewal for your current plan or switch plans with remaining balance applied.",
  "Доступ к скринеру откроется после активной оплаты.":
    "Screener access opens after an active payment.",
  "Сейчас статус аккаунта": "Current account status",
  "Текущая подписка": "Current subscription",
  "Открываю оплату...": "Opening payment...",
  "Выбор подписки": "Subscription selection",
  "Закрыть выбор подписки": "Close subscription selection",
  "Закрыть оплату": "Close payment",
  "Продление подписки": "Subscription renewal",
  "Смена тарифа": "Plan switch",
  "Оплата подписки": "Subscription payment",
  "Текущий тариф продлится от даты окончания активного периода.":
    "The current plan will renew from the end date of the active period.",
  "Остатка текущей подписки хватает для смены тарифа без доплаты.":
    "The remaining subscription balance is enough to switch plans without payment.",
  "Остаток текущей подписки зачтён в цену. Новый тариф начнётся после подтверждения оплаты.":
    "The remaining subscription balance has been applied to the price. The new plan starts after payment confirmation.",
  "Период": "Period",
  "Период подписки": "Subscription period",
  "Зачёт остатка": "Remaining balance credit",
  "Ваш срок после оплаты": "Your time after payment",
  "Сейчас осталось": "Currently remaining",
  "Вы добавите": "You will add",
  "и после оплаты будет": "and after payment you will have",
  "Метод оплаты": "Payment method",
  "Выбрать метод оплаты": "Choose payment method",
  "Актив": "Asset",
  "Выбрать актив": "Choose asset",
  "Валюта": "Currency",
  "Выбрать валюту": "Choose currency",
  "Я принимаю условия оплаты и понимаю, что подписка активируется после подтверждения платежа.":
    "I accept the payment terms and understand that the subscription activates after payment confirmation.",
  "Скрыть сообщение": "Hide message",
  "Ожидаем оплату": "Waiting for payment",
  "Ожидаем подтверждение CryptoBot": "Waiting for CryptoBot confirmation",
  "Последняя заявка CryptoBot": "Last CryptoBot order",
  "Ожидаем подтверждение Heleket": "Waiting for Heleket confirmation",
  "Последняя заявка Heleket": "Last Heleket order",
  "Вернуться к оплате": "Return to payment",
  "Отменяем...": "Canceling...",
  "Отменить оплату": "Cancel payment",
  "Меняю тариф...": "Switching plan...",
  "Ожидаем подтверждение": "Waiting for confirmation",
  "Скидка": "Discount",
  "экономия": "saved",
  "зачёт": "credit",
  "остаток на": "remaining for",
  "Закрыть Terms of Use": "Close Terms of Use",
  "Условия оплаты": "Payment terms",
  "Оплата подписки выполняется через выбранного платёжного посредника. После успешного подтверждения платежа доступ активируется на выбранный период.":
    "Subscription payment is handled through the selected payment provider. After successful payment confirmation, access activates for the selected period.",
  "Сетевые комиссии, срок подтверждения перевода и доступные криптовалюты зависят от выбранного метода оплаты и сети. Пользователь самостоятельно проверяет сумму, сеть и адрес перед оплатой.":
    "Network fees, confirmation time, and available cryptocurrencies depend on the selected payment method and network. The user must check the amount, network, and address before paying.",
  "Подписка не активируется до подтверждения платежа платёжным посредником. Если платёж завис, отклонён или отправлен с ошибкой, нужно обратиться в поддержку с деталями операции.":
    "The subscription does not activate until the payment provider confirms the payment. If a payment is stuck, rejected, or sent incorrectly, contact support with transaction details.",
  "Возвраты и ручная проверка платежей обрабатываются через поддержку. Сервис может запросить transaction hash, дату платежа, сумму и выбранный тариф.":
    "Refunds and manual payment checks are handled through support. The service may request the transaction hash, payment date, amount, and selected plan.",
  "Нажимая «Я прочитал», пользователь подтверждает, что ознакомился с условиями оплаты и понимает, что доступ появится только после подтверждения платежа.":
    "By clicking \"I have read\", the user confirms they have read the payment terms and understand that access appears only after payment confirmation.",
  "Я прочитал": "I have read",
  "Продлить тариф": "Renew plan",
  "Сменить тариф": "Switch plan",
  "Оплатить подписку": "Pay for subscription",
  "Оплатить": "Pay",
  "продление / месяц": "renewal / month",
  "смена тарифа": "plan switch",
  "с зачётом": "with credit",
  "хватит на": "covers",
  "Это даст": "This gives",
  "нового тарифа без доплаты.": "of the new plan without payment.",
  "К оплате уже применён зачёт": "A credit has already been applied",

  "Загрузка TWAP Detect": "Loading TWAP Detect",
  "Подписка активирована": "Subscription activated",
  "Тариф": "Plan",
  "подключён. Полный доступ к TWAP Detect уже открыт.":
    "is connected. Full access to TWAP Detect is now open.",
  "Можно переходить к скринеру и ловить новые сигналы без ограничений.":
    "You can open the screener and catch new signals without limits.",
  "Перейти к скринеру": "Go to screener",

  "Звуковое уведомление на новый TWAP": "Sound notification for a new TWAP",
  "Звуковой сигнал при появлении нового TWAP": "Sound when a new TWAP appears",
  "Голосовая озвучка": "Voice alerts",
  "Говорит тикер, сторону, размер и закрытие, даже если открыта другая вкладка":
    "Speaks the ticker, side, size, and close even if another tab is open",
  "Скорость голоса": "Voice speed",
  "Тон голоса": "Voice pitch",
  "Громкость голоса": "Voice volume",
  "Голос": "Voice",
  "Получать TWAP по вашим фильтрам в Telegram":
    "Receive TWAPs in Telegram based on your filters",
  "Telegram-бот ещё не настроен на сервере.":
    "Telegram bot is not configured on the server yet.",
  "Telegram-бот ещё поднимается. Повторите через несколько секунд.":
    "Telegram bot is still starting. Try again in a few seconds.",
  "Алерты включены для подключённого Telegram":
    "Alerts are enabled for the connected Telegram",
  "Алерты выключены, Telegram остаётся привязан":
    "Alerts are off, Telegram remains connected",
  "Подключить Telegram": "Connect Telegram",
  "Подключён": "Connected",
  "Telegram-аккаунт": "Telegram account",
  "vli (влияние на цену, %)": "vli (price impact, %)",
  "Скринер": "Screener",
  "Размер для тикеров": "Ticker sizes",
  "100k / 5m / 0 (выкл)": "100k / 5m / 0 (off)",
  "30m / 2h / 0 (выкл)": "30m / 2h / 0 (off)",
  "Черный список пуст": "Blacklist is empty",
  "Открыть все": "Open all",
  "Показать все": "Show all",
  "Удалить": "Delete",
  "Отмена": "Cancel",
  "Применить": "Apply",
  "Вставить": "Paste",
  "Вставь несколько адресов через пробел/запятую/перенос строки":
    "Paste multiple addresses separated by spaces, commas, or line breaks",
  "Неверный адрес": "Invalid address",
  "Должно быть 0x... (40 шестнадцатеричных символов).":
    "Must be 0x... (40 hexadecimal characters).",
  "Не добавлено": "Not added",
  "Невалидный список": "Invalid list",
  "Не найдено валидных адресов": "No valid addresses found",
  "Добавлено": "Added",
  "Отброшено": "Rejected",
  "Все отброшены": "All rejected",
  "Превышен лимит": "Limit exceeded",
  "занято из": "used out of",
  "вручную": "manual",
  "следить": "follow",
  "Вручную": "Manual",
  "Использовано": "Used",
  "Лимит": "Limit",
  "Удалите лишние кошельки или отпишитесь от TWAP'ов на дашборде.":
    "Remove extra wallets or unfollow TWAPs on the dashboard.",
  "TWAP'ы от этих кошельков не показываются на дашборде.":
    "TWAPs from these wallets are hidden on the dashboard.",
  "Золотые — добавлены вручную. Синие — заняты кнопкой «Следить».":
    "Gold are added manually. Blue are occupied by the Follow button.",
  "Импорт нескольких адресов разом": "Import multiple addresses at once",
  "Отменить Следить": "Cancel Follow",
  "Вариант звука": "Sound variant",
  "Послушать": "Listen",
  "открытие": "open",
  "закрытие": "close",
  "Колокольчик": "Chime",
  "Сигнал": "Signal",
  "Тик": "Tick",
  "Сирена": "Siren",
  "Гонг": "Gong",
  "Свист": "Whistle",
  "Аккорд с искрой": "Spark chord",
  "Двойной снап": "Double snap",
  "Лазер-свип": "Laser sweep",
  "Жирный alarm": "Heavy alarm",
  "Кино-удар с эхо": "Cinematic hit with echo",
  "UFO-свуш": "UFO swoosh",
  "откр / закр": "open / close",
  "MetaScalp не запущен. Запустите MetaScalp терминал на этом компьютере (порт 17845-17855) — фронт подхватит автоматически в течение нескольких секунд.":
    "MetaScalp is not running. Start the MetaScalp terminal on this computer (port 17845-17855); the frontend will detect it automatically within a few seconds.",
  "MetaScalp подключён": "MetaScalp connected",
  "MetaScalp подключён (порт": "MetaScalp connected (port",
  "но не найдено ни одного подключения к бирже. Настройте подключение в MetaScalp.":
    "but no exchange connections were found. Configure an exchange connection in MetaScalp.",
  "Перевыбрать порт MetaScalp": "Rescan MetaScalp port",
  "Сбросить кэш порта и заново просканировать 17845-17855":
    "Clear the port cache and rescan 17845-17855",
  "Поиск…": "Searching...",
  "Торговля включена": "Trading enabled",
  "включена": "enabled",
  "В избранное": "Add to favorites",
  "Убрать из избранного": "Remove from favorites",
  "В чёрный список": "Add to blacklist",
  "Убрать из чёрного списка": "Remove from blacklist",
  "Убрать из чёрного": "Remove from blacklist",
  "Убрать кошелёк из белого списка": "Remove wallet from whitelist",
  "Добавить в белый список (⭐ + приоритетный сигнал, лимит 10)":
    "Add to whitelist (⭐ + priority signal, limit 10)",
  "Убрать кошелёк из чёрного списка (твапы снова будут приходить)":
    "Remove wallet from blacklist (TWAPs will appear again)",
  "Не получать твапы от этого кошелька; все его карточки исчезнут с дашборда":
    "Hide TWAPs from this wallet; all of its cards will disappear from the dashboard",
  "Действия с кошельком": "Wallet actions",
  "Кошелёк в избранном — открыть меню для смены":
    "Wallet is in favorites — open menu to change",
  "Кошелёк в чёрном списке — открыть меню для смены":
    "Wallet is blacklisted — open menu to change",
  "Добавить кошелёк в избранное или чёрный список":
    "Add wallet to favorites or blacklist",
  "Показывать кнопку входа в позицию под каждой карточкой TWAP.":
    "Show the position-entry button under each TWAP card.",
  "Подключения недоступны — можно только выключить торговлю.":
    "Connections are unavailable; you can only disable trading.",
  "Сначала запустите MetaScalp и создайте подключение к бирже.":
    "Start MetaScalp first and create an exchange connection.",
};

const CYRILLIC_RE = /[А-Яа-яЁё]/;
const EN_ENTRIES = Object.entries(EN).sort((a, b) => b[0].length - a[0].length);
const RU_BY_EN = new Map<string, string>();
for (const [source, target] of EN_ENTRIES) {
  if (source === target || RU_BY_EN.has(target)) continue;
  RU_BY_EN.set(target, source);
}
const enTranslationCache = new Map<string, string>();
const EN_TRANSLATION_CACHE_LIMIT = 1000;

function cacheEnglishTranslation(source: string, translated: string) {
  if (enTranslationCache.size >= EN_TRANSLATION_CACHE_LIMIT) {
    const firstKey = enTranslationCache.keys().next().value as string | undefined;
    if (firstKey !== undefined) enTranslationCache.delete(firstKey);
  }
  enTranslationCache.set(source, translated);
}

function languageFromPath(pathname: string): AppLanguage | null {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname === "/ru" || pathname.startsWith("/ru/")) return "ru";
  return null;
}

function detectInitialLanguage(): AppLanguage {
  const pathLanguage = languageFromPath(window.location.pathname);
  if (pathLanguage) return pathLanguage;

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "ru" || stored === "en") return stored;
  } catch {
    // ignore storage access errors
  }

  const browserLanguage =
    typeof navigator !== "undefined" ? navigator.language || "" : "";
  return browserLanguage.toLowerCase().startsWith("ru") ? "ru" : "en";
}

export function translateText(value: string, language: AppLanguage) {
  if (language === "ru") return value;
  const cached = enTranslationCache.get(value);
  if (cached !== undefined) return cached;
  const exact = EN[value];
  if (exact) {
    cacheEnglishTranslation(value, exact);
    return exact;
  }

  if (!CYRILLIC_RE.test(value)) {
    return value;
  }

  let translated = value;
  for (const [source, target] of EN_ENTRIES) {
    if (!source || !translated.includes(source)) continue;
    translated = translated.split(source).join(target);
  }
  cacheEnglishTranslation(value, translated);
  return translated;
}

function toSourceLanguage(value: string) {
  if (!CYRILLIC_RE.test(value)) {
    const exact = RU_BY_EN.get(value);
    if (exact) return exact;
  }

  if (EN[value] !== undefined) return value;

  return value;
}

type I18nContextValue = {
  language: AppLanguage;
  setLanguage: (language: AppLanguage) => void;
  t: (value: string) => string;
};

const I18nContext = createContext<I18nContextValue | null>(null);

const originalTextNodes = new WeakMap<Text, string>();
const originalAttributes = new WeakMap<Element, Partial<Record<string, string>>>();
const TRANSLATABLE_ATTRIBUTES = ["aria-label", "title", "placeholder", "alt"] as const;

function shouldSkipTextNode(node: Text) {
  const parent = node.parentElement;
  if (!parent) return true;
  return Boolean(parent.closest("script, style, textarea, input, svg"));
}

function syncTextNode(node: Text, language: AppLanguage) {
  if (shouldSkipTextNode(node)) return;
  const current = node.nodeValue ?? "";
  if (!current.trim()) return;

  let original = originalTextNodes.get(node);
  if (original === undefined) {
    original = toSourceLanguage(current);
    originalTextNodes.set(node, original);
  } else {
    const renderedEn = translateText(original, "en");
    const currentSource = toSourceLanguage(current);
    if (currentSource !== original && current !== original && current !== renderedEn) {
      original = currentSource;
      originalTextNodes.set(node, original);
    }
  }

  const next = language === "en" ? translateText(original, "en") : original;
  if (node.nodeValue !== next) node.nodeValue = next;
}

function syncElementAttributes(element: Element, language: AppLanguage) {
  let originals = originalAttributes.get(element);
  for (const attr of TRANSLATABLE_ATTRIBUTES) {
    const current = element.getAttribute(attr);
    if (!current) continue;
    if (!originals) {
      originals = {};
      originalAttributes.set(element, originals);
    }
    let original = originals[attr];
    if (original === undefined) {
      original = toSourceLanguage(current);
      originals[attr] = original;
    } else {
      const renderedEn = translateText(original, "en");
      const currentSource = toSourceLanguage(current);
      if (currentSource !== original && current !== original && current !== renderedEn) {
        original = currentSource;
        originals[attr] = original;
      }
    }
    const next = language === "en" ? translateText(original, "en") : original;
    if (current !== next) element.setAttribute(attr, next);
  }
}

function syncTranslatedDom(root: ParentNode, language: AppLanguage) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();
  while (node) {
    syncTextNode(node as Text, language);
    node = walker.nextNode();
  }

  if (root instanceof Element) syncElementAttributes(root, language);
  root.querySelectorAll?.("*").forEach((element) => syncElementAttributes(element, language));
}

export function I18nProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<AppLanguage>(() => detectInitialLanguage());

  const setLanguage = useCallback((next: AppLanguage) => {
    setLanguageState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore storage access errors
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    const syncPathLanguage = () => {
      const pathLanguage = languageFromPath(window.location.pathname);
      if (!pathLanguage) return;
      setLanguageState(pathLanguage);
      try {
        window.localStorage.setItem(STORAGE_KEY, pathLanguage);
      } catch {
        // ignore storage access errors
      }
    };

    syncPathLanguage();
    window.addEventListener("popstate", syncPathLanguage);
    return () => window.removeEventListener("popstate", syncPathLanguage);
  }, []);

  useEffect(() => {
    syncTranslatedDom(document.body, language);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "characterData" && mutation.target instanceof Text) {
          syncTextNode(mutation.target, language);
        }
        if (mutation.type === "attributes" && mutation.target instanceof Element) {
          syncElementAttributes(mutation.target, language);
        }
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Text) syncTextNode(node, language);
          if (node instanceof Element) syncTranslatedDom(node, language);
        });
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [...TRANSLATABLE_ATTRIBUTES],
      characterData: true,
      childList: true,
      subtree: true,
    });
    return () => observer.disconnect();
  }, [language]);

  const t = useCallback((value: string) => translateText(value, language), [language]);

  const value = useMemo<I18nContextValue>(
    () => ({ language, setLanguage, t }),
    [language, setLanguage, t],
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const value = useContext(I18nContext);
  if (value) return value;
  return {
    language: "ru" as AppLanguage,
    setLanguage: () => undefined,
    t: (text: string) => text,
  };
}

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { language, setLanguage, t } = useI18n();
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement | null>(null);

  const options: Array<{ label: string; name: string; value: AppLanguage }> = [
    { label: "ENG", name: "English", value: "en" },
    { label: "RUS", name: "Russian", value: "ru" },
  ];
  const selected = options.find((option) => option.value === language) ?? options[0];

  useEffect(() => {
    if (!open) return;
    const closeOnPointerDown = (event: PointerEvent) => {
      if (rootRef.current?.contains(event.target as Node)) return;
      setOpen(false);
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("pointerdown", closeOnPointerDown);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnPointerDown);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  return (
    <div
      ref={rootRef}
      className={`language-switcher ${className}`.trim()}
      data-open={open ? "true" : undefined}
    >
      <button
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={t("Switch language")}
        className="language-switcher-trigger"
        type="button"
        onClick={() => setOpen((value) => !value)}
      >
        <span aria-hidden className={`language-flag language-flag--${selected.value}`} />
        <span>{selected.label}</span>
        <span aria-hidden className="language-switcher-caret">▾</span>
      </button>
      {open ? (
        <div className="language-switcher-menu" role="listbox" aria-label={t("Language")}>
          {options.map((option) => (
            <button
              aria-label={`${option.name} ${option.label}`}
              aria-selected={language === option.value}
              className={language === option.value ? "is-active" : undefined}
              key={option.value}
              role="option"
              type="button"
              onClick={() => {
                setLanguage(option.value);
                const path = window.location.pathname;
                if (path === "/" || path === "/ru" || path === "/en") {
                  window.history.pushState(null, "", `/${option.value}${window.location.search}${window.location.hash}`);
                  window.dispatchEvent(new PopStateEvent("popstate"));
                }
                setOpen(false);
              }}
            >
              <span aria-hidden className={`language-flag language-flag--${option.value}`} />
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
